/* Product page bundle widget. Replaces the Kaching tier block.
   Tiers, per unit gi/colour/size with ships now and pre order flags,
   optional add ons, one add to cart.

   A tier shows a free shipping badge when its TOTAL clears cfg.freeShipping,
   which comes from snippets/ig-free-shipping.liquid, the same number the cart
   drawer uses. The badge text is sentence case here and uppercased by CSS, the
   same way .pb__save-pill and .pb__flag are handled. */
(function () {
  'use strict';

  /* Truck, currentColor so it inherits the pill's green. */
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M2 6.5A1.5 1.5 0 0 1 3.5 5h9A1.5 1.5 0 0 1 14 6.5V8h3.1c.5 0 .95.25 1.23.66l2.4 3.5c.17.25.27.55.27.86V16a1 1 0 0 1-1 1h-1.1a2.9 2.9 0 0 0-5.8 0H9.9a2.9 2.9 0 0 0-5.8 0H3a1 1 0 0 1-1-1V6.5ZM14 9.8v2.9h5.2l-2-2.9H14Z"/>' +
    '<circle cx="7" cy="17.6" r="1.9" fill="currentColor"/>' +
    '<circle cx="17" cy="17.6" r="1.9" fill="currentColor"/>' +
    '</svg>';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-product-bundle]');
    if (root) init(root);
  });

  function init(root) {
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-pb-data]').textContent); }
    catch (e) { return; }
    if (!cfg.products || !cfg.products.length) return;

    var byHandle = {};
    cfg.products.forEach(function (p) { byHandle[p.h] = p; });

    var sym = cfg.currency || '$';
    var tiers = cfg.tiers;
    var chosenTier = cfg.defaultTier || 0;
    var units = [];
    var addons = {};

    var tiersWrap = root.querySelector('[data-pb-tiers]');
    var errEl = root.querySelector('[data-pb-err]');

    function money(c) {
      return sym + (c / 100).toLocaleString('en-US',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function colours(p) {
      var seen = {}, out = [];
      p.v.forEach(function (v) {
        if (seen[v.c]) return;
        seen[v.c] = 1;
        out.push({ name: v.c, ok: p.v.some(function (x) { return x.c === v.c && x.a; }) });
      });
      return out;
    }
    function sizes(p, colour) {
      var seen = {}, out = [];
      p.v.forEach(function (v) {
        if (v.c !== colour || seen[v.s]) return;
        seen[v.s] = 1;
        out.push({ name: v.s, ok: v.a, st: v.st });
      });
      return out;
    }
    function variantOf(p, colour, size) {
      for (var i = 0; i < p.v.length; i++) {
        if (p.v[i].c === colour && p.v[i].s === size) return p.v[i];
      }
      return null;
    }
    function firstSellable(p) {
      for (var i = 0; i < p.v.length; i++) if (p.v[i].a) return p.v[i];
      return p.v[0];
    }

    function seed(handle) {
      var p = byHandle[handle] || cfg.products[0];
      var v = firstSellable(p);
      return { h: p.h, c: v ? v.c : null, s: v ? v.s : null, id: v ? v.id : null };
    }

    function syncUnits() {
      var want = tiers[chosenTier].qty;
      while (units.length < want) units.push(seed(cfg.current));
      units.length = want;
    }

    function flag(st) {
      if (st === 'ships now') return '<span class="pb__flag is-now">ships now</span>';
      if (st === 'pre order') return '<span class="pb__flag is-pre">pre order</span>';
      if (st === 'sold out')  return '<span class="pb__flag is-out">sold out</span>';
      return '';
    }

    function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }

    function unitHtml(u, i) {
      var showGi = tiers[chosenTier].qty > 1 && cfg.products.length > 1;
      var p = byHandle[u.h];
      var cs = colours(p);
      var ss = u.c ? sizes(p, u.c) : [];
      var cur = u.c && u.s ? variantOf(p, u.c, u.s) : null;

      return '' +
      '<div class="pb__unit" data-pb-unit="' + i + '">' +
        (p.img ? '<img class="pb__thumb" src="' + p.img + '" alt="" loading="lazy" width="46" height="46">' : '<span class="pb__thumb"></span>') +
        '<div class="pb__unit-body">' +
          '<div class="pb__unit-name">' + esc(p.t) +
            (cur ? ' ' + flag(cur.st) : '') +
          '</div>' +
          '<div class="pb__selects">' +
            (showGi ?
              '<span class="pb__sel"><select data-pb-gi="' + i + '" aria-label="Gi">' +
                cfg.products.map(function (x) {
                  return '<option value="' + esc(x.h) + '"' + (x.h === u.h ? ' selected' : '') + '>' + esc(x.t) + '</option>';
                }).join('') +
              '</select></span>' : '') +
            '<span class="pb__sel"><select data-pb-colour="' + i + '" aria-label="Colour">' +
              cs.map(function (c) {
                return '<option value="' + esc(c.name) + '"' + (c.name === u.c ? ' selected' : '') + (c.ok ? '' : ' disabled') + '>' + esc(c.name) + '</option>';
              }).join('') +
            '</select></span>' +
            '<span class="pb__sel"><select data-pb-size="' + i + '" aria-label="Size">' +
              ss.map(function (s) {
                var tag = s.st === 'pre order' ? ' (pre order)' : ((s.st === 'sold out' || !s.ok) ? ' (sold out)' : '');
                return '<option value="' + esc(s.name) + '"' + (s.name === u.s ? ' selected' : '') + (s.ok ? '' : ' disabled') + '>' + esc(s.name) + tag + '</option>';
              }).join('') +
            '</select></span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function totals() {
      var t = tiers[chosenTier];
      var sum = t.each * t.qty;
      cfg.addons.forEach(function (a) { if (addons[a.id]) sum += a.price; });
      return sum;
    }

    function render() {
      syncUnits();

      tiersWrap.innerHTML = tiers.map(function (t, i) {
        var was = cfg.base * t.qty;
        var now = t.each * t.qty;
        var pct = was > 0 ? Math.round((1 - now / was) * 100) : 0;
        var on = i === chosenTier;
        var ships = cfg.freeShipping > 0 && now >= cfg.freeShipping;
        return '' +
          '<div class="pb__tier' + (on ? ' is-on' : '') + '" data-pb-tier="' + i + '" role="button" tabindex="0">' +
            (t.ribbon ? '<span class="pb__ribbon">' + esc(t.ribbon) + '</span>' : '') +
            '<div class="pb__tier-head">' +
              '<span class="pb__radio"></span>' +
              '<span class="pb__tier-main">' +
                '<span class="pb__tier-name">' + esc(t.label) +
                  (pct > 0 ? ' <span class="pb__save-pill">save ' + pct + '%</span>' : '') +
                  (ships ? ' <span class="pb__ship-pill">' + TRUCK + 'Free shipping</span>' : '') +
                '</span>' +
                '<span class="pb__tier-sub">' + (t.qty > 1 ? money(t.each) + ' each' : esc(t.sub || '')) + '</span>' +
              '</span>' +
              '<span class="pb__tier-price">' +
                '<span class="pb__price">' + money(now) + '</span>' +
                (pct > 0 ? '<span class="pb__was">' + money(was) + '</span>' : '') +
              '</span>' +
            '</div>' +
            (on ? '<div class="pb__units">' + units.map(unitHtml).join('') + '</div>' : '') +
          '</div>';
      }).join('');

      var totalEl = root.querySelector('[data-pb-total]');
      if (totalEl) totalEl.textContent = money(totals());
    }

    root.addEventListener('click', function (ev) {
      var tier = ev.target.closest ? ev.target.closest('[data-pb-tier]') : null;
      if (tier) {
        var i = parseInt(tier.getAttribute('data-pb-tier'), 10);
        if (i !== chosenTier) { chosenTier = i; render(); }
      }
    });

    root.addEventListener('change', function (ev) {
      var el = ev.target;
      var i;
      if (el.hasAttribute('data-pb-gi')) {
        i = +el.getAttribute('data-pb-gi');
        units[i] = seed(el.value);
        render();
      } else if (el.hasAttribute('data-pb-colour')) {
        i = +el.getAttribute('data-pb-colour');
        var p = byHandle[units[i].h];
        units[i].c = el.value;
        var ss = sizes(p, el.value).filter(function (s) { return s.ok; });
        var keep = ss.filter(function (s) { return s.name === units[i].s; })[0];
        var pick = keep || ss[0];
        units[i].s = pick ? pick.name : null;
        var v = pick ? variantOf(p, el.value, pick.name) : null;
        units[i].id = v ? v.id : null;
        render();
      } else if (el.hasAttribute('data-pb-size')) {
        i = +el.getAttribute('data-pb-size');
        var p2 = byHandle[units[i].h];
        var v2 = variantOf(p2, units[i].c, el.value);
        if (v2) { units[i].s = v2.s; units[i].id = v2.id; }
        render();
      } else if (el.hasAttribute('data-pb-addon')) {
        addons[el.getAttribute('data-pb-addon')] = el.checked;
        render();
      }
    });

    root.querySelector('[data-pb-cta]').addEventListener('click', function () {
      var btn = this;
      var items = units.filter(function (u) { return u.id; })
                       .map(function (u) { return { id: u.id, quantity: 1 }; });
      cfg.addons.forEach(function (a) { if (addons[a.id]) items.push({ id: a.id, quantity: 1 }); });
      if (!items.length) return;

      errEl.hidden = true;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart.'); });
        return r.json();
      }).then(function () {
        /* the drawer opens itself off the add; only navigate if there is none */
        btn.disabled = false;
        btn.textContent = label;
        if (!window.IGCart) window.location.href = '/cart';
      }).catch(function (e) {
        errEl.textContent = e.message;
        errEl.hidden = false;
        btn.disabled = false;
        btn.textContent = label;
      });
    });

    var host = document.querySelector('.item-info .block.type-buy_buttons')
            || document.querySelector('.item-info');
    if (host && host.parentNode) host.parentNode.insertBefore(root, host);
    document.documentElement.classList.add('pb-active');

    render();
  }
})();
